// Ajax CSRF
$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});

$(() => {
    // Logout form
    $("#logout-link").click((event) => {
        event.preventDefault();
        document.getElementById("logout-form").submit();
    });

    // Select 2
    $.fn.select2.defaults.set("theme", "bootstrap-5");
    $.fn.select2.defaults.set(
        "language",
        document.documentElement.lang || "es",
    );
    $(".select2").select2();

    window.initProductSelect = (selector) => {
        $(selector)
            .not(".select2-hidden-accessible")
            .select2({
                ajax: {
                    url: "/api/products",
                    dataType: "json",
                    delay: 250,
                    data(params) {
                        return {
                            q: params.term || "",
                            page: params.page || 1,
                        };
                    },
                    processResults(data) {
                        return {
                            results: data.results,
                            pagination: { more: data.pagination.more },
                        };
                    },
                    cache: true,
                },
                width: "100%",
            })
            .on("change", function () {
                $(this).trigger("input");
            });
    };

    initProductSelect(".select2-product");
    Livewire.hook("message.processed", () => {
        initProductSelect(".select2-product");
    });

    window.addEventListener("init-product-select", () => {
      setTimeout(() => {
        initProductSelect(".select2-product");
      }, 1500)
    });

    // Date Time Picker
    $(".date-picker").flatpickr({
        altInput: true,
        locale: {
            firstDayOfWeek: 0,
        },
        allowInput: true,
    });
    $(".datetime-picker").flatpickr({
        altInput: false,
        enableTime: true,
        locale: {
            firstDayOfWeek: 0,
        },
        allowInput: true,
    });

    // Tooltips
    $('[data-coreui-toggle="tooltip"]').tooltip();

    window.addEventListener("hideProductModal", () => {
        $("#productModal").modal("hide");
    });

    window.addEventListener("hideWorkerModal", () => {
        $("#workerModal").modal("hide");
    });

    $("#deleteMedia").on("click", () => {
        $("#delete_media").click();
        $("#hide_1").addClass("d-none");
        $("#deleteMedia").addClass("d-none");
    });
});
